import { Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import React from 'react';
import Home from './pages/home';
import Withoutnav from './components/withoutnav';
import MarketingLayout from './layouts/MarketingLayout';
import ScrollToTop from './components/ScrollToTop';

const ContactUs = React.lazy(() => import('./pages/contact_us'));
const AboutUs = React.lazy(() => import('./pages/about_us'));
const Demo = React.lazy(() => import('./pages/demo'));
const Products = React.lazy(() => import('./pages/products'));
const Register = React.lazy(() => import('./pages/register'));
const Login = React.lazy(() => import('./pages/login'));
const Pricing = React.lazy(() => import('./pages/pricing'));
const GenerateAIPatientSummary = React.lazy(() => import('./pages/generate_ai_patient_summary'));
const NutritionalAgent = React.lazy(() => import('./pages/nutritional_agent'));
const VoiceReceptionistAgent = React.lazy(() => import('./pages/voice_receptionist_agent'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy_policy'));
const TermsAndServices = React.lazy(() => import('./pages/terms_and_services'));
const CaseStudies = React.lazy(() => import('./pages/case_studies'));
const ForOrthopedics = React.lazy(() => import('./pages/for_orthopedics'));
const ForPhysiotherapy = React.lazy(() => import('./pages/for_physiotherapy'));
const ForCardiology = React.lazy(() => import('./pages/for_cardiology'));
const ForPulmonology = React.lazy(() => import('./pages/for_pulmonology'));
const ForOncology = React.lazy(() => import('./pages/for_oncology'));
const CompareHealthplix = React.lazy(() => import('./pages/compare_healthplix'));
const SecurityAbdm = React.lazy(() => import('./pages/security_abdm'));

function BlogRedirect() {
  React.useEffect(() => {
    window.location.replace('https://blog.deepaarogya.com/');
  }, []);
  return null;
}
const PageNotFound = React.lazy(() => import('./pages/PageNotFound'));

function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
        <Routes>
          <Route element={<Withoutnav />}>
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
          </Route>

          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-services" element={<TermsAndServices />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/for/orthopedics" element={<ForOrthopedics />} />
            <Route path="/for/physiotherapy" element={<ForPhysiotherapy />} />
            <Route path="/for/cardiology" element={<ForCardiology />} />
            <Route path="/for/pulmonology" element={<ForPulmonology />} />
            <Route path="/for/oncology" element={<ForOncology />} />
            <Route path="/compare/healthplix" element={<CompareHealthplix />} />
            <Route path="/resources" element={<BlogRedirect />} />
            <Route path="/security-abdm" element={<SecurityAbdm />} />
            <Route path="/generate-ai-patient-summary" element={<GenerateAIPatientSummary />} />
            <Route path="/nutritional-agent" element={<NutritionalAgent />} />
            <Route path="/voice-receptionist-agent" element={<VoiceReceptionistAgent />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
    </HelmetProvider>
  );
}

export default App;
